import { render, staticRenderFns } from "./FaqModal.vue?vue&type=template&id=3868d078&"
import script from "./FaqModal.vue?vue&type=script&lang=ts&"
export * from "./FaqModal.vue?vue&type=script&lang=ts&"
import style0 from "./FaqModal.vue?vue&type=style&index=0&id=3868d078&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports